import React, { PropTypes } from 'react';
import { CDN_PROVIDERS } from '../../constants/cdnConstants';

const ColumnHeaderIcon = ({cdnCode}) =>
    (<span><div className={`cdn-provider-icon ${cdnCode}`} />{CDN_PROVIDERS[cdnCode].code}</span>);

ColumnHeaderIcon.PropTypes = {
    cdnCode: PropTypes.bool.isRequired,
};

export default ColumnHeaderIcon;



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/ColumnHeaderIcon.js
 **/